export const bookmarkKeys = {
  all: ['bookmarks'] as const,
  type: (key: string) => [...bookmarkKeys.all, key] as const,
  id: (id: string, key: string) => [...bookmarkKeys.all, id, key] as const,
};
